import { render, staticRenderFns } from "./languages-panel.vue?vue&type=template&id=48851a4f"
import script from "./languages-panel.vue?vue&type=script&lang=js"
export * from "./languages-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports